"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function detachBindings(bindings) {
    bindings.forEach(function (binding) { return binding.detach(); });
}
var ExtendedSignal = (function () {
    function ExtendedSignal(_baseSignal) {
        this._baseSignal = _baseSignal;
    }
    ExtendedSignal.merge = function () {
        var signals = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            signals[_i] = arguments[_i];
        }
        return new ExtendedSignal({
            add: function (listener) {
                var bindings = signals.map(function (signal) { return signal.add(listener); });
                return {
                    detach: function () {
                        detachBindings(bindings);
                    },
                };
            },
        });
    };
    ExtendedSignal.promisify = function (resolveSignal, rejectSignal) {
        return new Promise(function (resolve, reject) {
            var bindings = [];
            if (rejectSignal) {
                bindings.push(rejectSignal.add(function (payload) {
                    detachBindings(bindings);
                    reject(payload);
                }));
            }
            bindings.push(resolveSignal.add(function (payload) {
                detachBindings(bindings);
                resolve(payload);
            }));
        });
    };
    ExtendedSignal.prototype.add = function (listener) {
        return this._baseSignal.add(listener);
    };
    ExtendedSignal.prototype.addOnce = function (listener) {
        var binding = this._baseSignal.add(function (payload) {
            binding.detach();
            listener(payload);
        });
        return binding;
    };
    ExtendedSignal.prototype.filter = function (filter) {
        var _this = this;
        return new ExtendedSignal({
            add: function (listener) { return _this._baseSignal.add(function (payload) {
                if (filter(payload)) {
                    listener(payload);
                }
            }); },
        });
    };
    ExtendedSignal.prototype.map = function (transform) {
        var _this = this;
        return new ExtendedSignal({
            add: function (listener) { return _this._baseSignal.add(function (payload) { return listener(transform(payload)); }); },
        });
    };
    ExtendedSignal.prototype.merge = function () {
        var signals = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            signals[_i] = arguments[_i];
        }
        return ExtendedSignal.merge.apply(ExtendedSignal, [this._baseSignal].concat(signals));
    };
    ExtendedSignal.prototype.promisify = function (rejectSignal) {
        return ExtendedSignal.promisify(this._baseSignal, rejectSignal);
    };
    ExtendedSignal.prototype.readOnly = function () {
        var _this = this;
        return new ExtendedSignal({
            add: function (listener) { return _this._baseSignal.add(listener); },
        });
    };
    return ExtendedSignal;
}());
exports.ExtendedSignal = ExtendedSignal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/micro-signals/lib/extended-signal.js
// module id = 157
// module chunks = 0